export function formatDate(date: Date, opts?: Intl.DateTimeFormatOptions,) {
  return new Intl.DateTimeFormat("ru-RU", {
    month: "long",
    day: "numeric",
    year: date.getFullYear() > new Date().getFullYear() ? "numeric" : undefined,
    ...opts,
  },).format(date,);
}

export function getDateInDays(daysToAdd: number,): string {
  const date = new Date();
  date.setDate(date.getDate() + daysToAdd,);
  return date.toISOString().split("T",)[0];
}
